import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ConclusionPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Conclusion</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Bioenergy has the potential to meet the household energy demand
              through decentralized electricity generation and adoption of
              improved BETs in Uttara Kannada district,. The supply/demand ratio
              of bioresources in the district ranges from less than 0.5
              (Bioresource deficit) to more than 2. The coastal and the extreme
              eastern part of the district (coastal villages of Karwar, Ankola,
              Kumta, Honnavar and Bhatkal with eastern part of Mundgod and
              Haliyal) are fuel wood deficit places. The bioresource supply is
              dwindling in the district evident from the reduced bioresource
              supply to demand ratio from 8-9 to 2 from 2000 to 2013. This
              necessitates sustainable management approaches with augmentation
              of forest resources.
            </p>
            <p>
              In coastal regions (Kumta, Honnavar, Ankola, Bhatkal, Karwar),
              availability of agro-horticultural residues is more than the
              current demand which has the potential to meet the rural household
              energy demand. Similarly in Sirsi, Siddapur and Yellapur taluks,
              forest biomass potential could meet the domestic energy
              demand.&nbsp; In Mundgod, Haliyal and in coastal villages,
              availability of animal residues provides the scope for biogas
              production. About 40% of the villages have adequate biogas
              potential to meet the domestic needs. These villages are to be
              considered for dissemination of biogas technology in the district.
              Biogas can also be used for electricity generation and the
              byproduct, i.e. slurry is used for organic manure production which
              is a very good fertilizer. Advanced BETs will encourage the
              bioenergy use and make the application simpler and efficient.
              Improved cook stoves, biomass gasification and other new bioenergy
              technologies are yet to be available in rural areas which could
              change the older energy conversion pattern with higher efficiency.
              BETs are technically feasible economically viable and
              environmental friendly apart from ensuring sustenance of
              resources.
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ConclusionPage;
